import { Link } from "react-router-dom";
import { ArrowUpRight, Home } from "lucide-react";

export default function NotFound() {
    return (
        <main
            data-testid="not-found-page"
            className="min-h-screen bg-ink text-bone flex flex-col"
        >
            <div className="absolute inset-0 pointer-events-none">
                <div
                    className="absolute inset-0 opacity-40"
                    style={{
                        background:
                            "radial-gradient(800px circle at 30% 20%, rgba(200,122,56,0.15), transparent 60%)",
                    }}
                />
            </div>

            <header className="relative max-w-[1400px] mx-auto w-full px-6 lg:px-10 py-6">
                <Link to="/" className="inline-flex items-center gap-3" data-testid="not-found-brand">
                    <img src="/logo.png" alt="Aximo Studios" className="h-10 w-auto" />
                </Link>
            </header>

            <section className="relative flex-1 max-w-[1400px] mx-auto w-full px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center py-20">
                <div className="lg:col-span-7">
                    <div className="text-[10px] uppercase tracking-[0.25em] text-ember mb-6">
                        404 · The page wandered off
                    </div>
                    <h1
                        data-testid="not-found-heading"
                        className="font-display tracking-tightest text-bone text-7xl sm:text-8xl lg:text-[140px] leading-[0.92] mb-8"
                    >
                        Lost in the{" "}
                        <span className="font-serif-i italic text-ember">edit.</span>
                    </h1>
                    <p className="text-bone-300 text-base lg:text-lg max-w-xl leading-relaxed mb-10">
                        We couldn&apos;t find the page you were looking for — maybe
                        it got cut from the final reel. While you&apos;re here,
                        these are worth a look.
                    </p>
                    <div className="flex flex-wrap items-center gap-4">
                        <Link
                            to="/"
                            data-testid="not-found-cta-home"
                            className="btn-ember inline-flex items-center gap-2 h-12 px-6 text-sm font-medium tracking-wide"
                        >
                            <Home className="w-4 h-4" />
                            Back to studio
                        </Link>
                        <Link
                            to="/#work"
                            data-testid="not-found-cta-work"
                            className="btn-outline-bone inline-flex items-center gap-2 h-12 px-6 text-sm font-medium tracking-wide"
                        >
                            See selected work
                            <ArrowUpRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <div className="border border-white/10 bg-ink-800/40 p-6 lg:p-8">
                        <div className="text-[10px] uppercase tracking-[0.25em] text-bone-500 mb-4">
                            Featured · Halcyon rebrand
                        </div>
                        <img
                            src="https://images.unsplash.com/photo-1702479744181-2d6b58941583?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwYWdlbmN5JTIwcG9ydGZvbGlvJTIwbW9ja3VwfGVufDB8fHx8MTc3NzYzNTMxMHww&ixlib=rb-4.1.0&q=85"
                            alt="Halcyon rebrand"
                            className="w-full h-64 object-cover mb-5"
                        />
                        <p className="text-sm text-bone-300 leading-relaxed mb-4">
                            A measured rebrand for a 14-year-old advisory firm —
                            built to age well, not date itself.
                        </p>
                        <Link
                            to="/work/halcyon"
                            data-testid="not-found-case-link"
                            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-ember link-underline"
                        >
                            Read the case study
                            <ArrowUpRight className="w-3.5 h-3.5" />
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}
